import React from 'react';
import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material';
import EastIcon from '@mui/icons-material/East';

const Completion = ({ summary }) => {
  function CircularProgressWithIcon(props: any) {
    return (
      <div>
        <Box position="relative" display="inline-flex">
          <CircularProgress
            variant="determinate"
            sx={{
              color: (theme) =>
                theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
            }}
            size={160}
            thickness={9}
            {...props}
            value={100}
          />
          <CircularProgress
            variant="determinate"
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light' ? '#0069E4' : '#308fe8',
              position: 'absolute',
              left: 0
              //   [`& .${circularProgressClasses.circle}`]: {
              //     strokeLinecap: 'round'
              //   },
            }}
            style={{ transform: 'rotate(20deg)' }}
            size={160}
            thickness={9}
            value={props.content}
            {...props}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              style={{ color: '#0069E4', fontWeight: '700', fontSize: '20px' }}
            >
              {props.content}%
            </Typography>
          </Box>
        </Box>
      </div>
    );
  }

  return (
    <Card style={{ padding: '0.5rem' }}>
      <Grid
        item
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Grid item style={{ display: 'flex', justifyContent: 'center' }}>
          <Typography
            sx={{
              pb: 2,
              fontSize: '21px',
              fontWeight: '600',
              color: '#5B5B5B'
            }}
          >
            Completion
          </Typography>
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <CircularProgressWithIcon content={summary?.projectCompletion} />
        </Grid>
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            marginTop: '0.25rem'
          }}
        >
          <Grid item style={{}}>
            <Typography sx={{ color: '#5B5B5B' }}>
              {summary?.projectCompletion}%
            </Typography>
          </Grid>
          <Grid
            item
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <EastIcon sx={{ color: '#C0C0C0' }} />
            <Typography sx={{ color: '#00B26A' }}>
              {summary?.projectCompletion - summary?.projectCompletion}%
            </Typography>
          </Grid>
          <Grid item style={{}}>
            <Typography sx={{ color: '#5B5B5B' }}>
              {summary?.projectCompletion}%
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default Completion;
